import { formatMoney } from "infra/helpers/number";
import { useMemo } from "react";
import { PDFTableColumn } from "components/PDF/Table";
import { Text } from "@react-pdf/renderer";
import { BalancoFinanceiroReceitaResponse } from "core/features/relatorios/typings";
import moment from "moment";

function useRelatorioBalancoFinanceiroReceitasPdfColumns(
  title?: string
): PDFTableColumn<BalancoFinanceiroReceitaResponse>[] {
  return useMemo(() => {
    const columns: PDFTableColumn<BalancoFinanceiroReceitaResponse>[] = [];

    const commonStyles = (hasChildren = false) =>
      ({
        color: "#000",
        fontWeight: hasChildren ? "medium" : undefined,
      } as Record<string, string | number>);

    columns.push({
      title: title || "",
      flexGrow: 4,
      render: (original) => {
        const breadcrumbLevel = original.breadcrumb?.match(/\./g)?.length || 0;
        return (
          <Text
            style={{
              paddingLeft: breadcrumbLevel * 10,
              ...commonStyles(!!original.items.length),
            }}
          >
            {original.breadcrumb} {original.nome}
          </Text>
        );
      },
    });

    columns.push({
      title: "Competência",
      width: "4cm",
      textAlign: "center",
      render: (original) => (
        <Text
          style={{
            ...commonStyles(!!original.items.length),
            textAlign: "center",
          }}
        >
          {original.mesCompetencia
            ? moment(original.mesCompetencia, "YYYY-MM").format("MM/YYYY")
            : ""}
        </Text>
      ),
    });

    columns.push({
      title: "Valor",
      width: "4cm",
      textAlign: "right",
      render: (original) => (
        <Text style={{ ...commonStyles(!!original.items.length) }}>
          {original.items.length
            ? formatMoney((original.valor ?? 0) + original.valorItems)
            : formatMoney(original.valor)}
        </Text>
      ),
    });

    return columns;
  }, [title]);
}

export default useRelatorioBalancoFinanceiroReceitasPdfColumns;
